import React from "react";

import PeggedSalaryCalculator from "./PeggedSalaryCalculator";

function App() {
  return (
    <div style={{ width: "600px" }}>
      <hr />
      <PeggedSalaryCalculator />
    </div>
  );
}

export default App;
